export default {"src":"/_next/static/media/CockRoachDB.99cae187.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};